import React, { useContext, useEffect, useState } from 'react'
import { Link } from "react-router-dom"
import { Container, Row, Col, Nav, NavItem, NavLink } from 'reactstrap'
import MegaSearch from './MegaSearch'
import { useIntl } from 'react-intl'
// ** international
import { IntlContext } from '../../utils/context/Internationalization'
import { useConfig } from '../../utils/context/ConfigContext'
export default function FirstHeader() {
    const intl = useIntl()
    const [pathName, setPathname] = useState("")
    const pathSplit = window.location.pathname.split('/')
    const lang = pathSplit[1]
    const { config } = useConfig();
    useEffect(() => {
        setPathname(window.location.pathname)
    }, [window.location.pathname])
    const context = useContext(IntlContext)
    return (
        <Container className="wp_firstheader">
            <Row>
                <Col md={4} sm={7} >
                    <a href={`${lang === 'vi' ? '/vi' : ''}/`}>
                        <img src={config.logoUrl}
                            className="img-fluid py-2 logo_header"
                            alt="image">
                        </img>
                        <img src={config.logoMobileUrl}
                            className="img-fluid py-2 logo_header_mobile"
                            alt="image">
                        </img>
                    </a>
                    {
                        pathName.includes("kvtt") && <span className=' d-inline-block font-weight-bold text-uppercase'>{intl.formatMessage({ id: 'faculty of information and technology' })}</span>
                    }
                </Col>
                <Col md={4}></Col>
                <Col md={4} sm={4} style={{ margin: 'auto', zIndex: '999' }}>
                    {/* <div className="text-right mb-1 d-md-block d-none">
                        <span onClick={(e) => {
                            e.preventDefault()
                            context.switchLanguage('vn')
                        }}>
                            <img src={require('assets/img/custom/logo/vn.png').default}
                                className="img-fluid mx-2"
                                alt="image"
                                style={{ width: '28px', cursor: 'pointer' }}>
                            </img>
                        </span>
                        <span onClick={(e) => {
                            e.preventDefault()
                            context.switchLanguage('en')
                        }}>
                            <img src={require('assets/img/custom/logo/eng.png').default}
                                className="img-fluid"
                                alt="image"
                                style={{ width: '31px', cursor: 'pointer' }}>
                            </img>
                        </span>
                    </div> */}
                    <MegaSearch></MegaSearch>
                </Col>
                <Col sm={1}>

                </Col>
            </Row>
        </Container>
    )
}
